import { ApiConstant } from "@/const";
import { E2EService } from "@/services";
import GlobalApi, { ApiResponse } from "./config/api.config";

export type ResponseLoginType = {
  accessToken: string;
  userUid: string;
  name: string;
  role: number;
  avatar: string;
  thirdPartyToken: string;
};

export const login = async (username: string, password: string) => {
  const payload = { username, password };
  const response = await GlobalApi.toCamel().post<ApiResponse<ResponseLoginType>>(ApiConstant.POST_LOGIN, payload);

  if (response.ok && response.data && response.data.data) {
    await E2EService.loginSdk({ ...response.data.data, email: username });
    return true;
  }

  throw response;
};
